import React from 'react'
import styles from '../index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import { Grid } from '@mui/material'
import SelectCustom from '../../atoms/select/SelectCustom'

const Caterer = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>Caterer Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Provided by
							</label>
							<SelectCustom
								label="Select"
								options={[
									{
										value: 'Venue’s in-house team',
										label: 'Venue’s in-house team',
									},
									{
										value: 'External caterer',
										label: 'External caterer',
									},
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Company contact name
							</label>
							<InputCustom
								placeholder="Enter Company contact name"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Company Contact Number
							</label>
							<InputCustom
								placeholder="Enter Company Contact Number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Timeline Contributions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Delivery time
							</label>
							<InputCustom
								placeholder="Enter Delivery time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Setup start time
							</label>
							<InputCustom
								placeholder="Enter Setup start time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Service start & end time
							</label>
							<InputCustom
								placeholder="Enter Service start & end time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Cleanup/teardown time
							</label>
							<InputCustom
								placeholder="Enter Cleanup/teardown time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Coffee/dessert service time
							</label>
							<InputCustom
								placeholder="Enter Coffee/dessert service time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Venue kitchen access time
							</label>
							<InputCustom
								placeholder="Enter Venue kitchen access time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Power/water needs
							</label>
							<InputCustom
								placeholder="Enter Power/water needs"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								placeholder="Enter Setup / teardown duration"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default Caterer
